import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3464783c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewCheckbox__input" }
const _hoisted_2 = {
  key: 0,
  class: "fas fa-check fa-xs text-white"
}
const _hoisted_3 = {
  key: 1,
  class: "fas fa-minus fa-xs text-white"
}
const _hoisted_4 = {
  key: 0,
  class: "NewCheckbox__text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["NewCheckbox", { disabled: _ctx.disabled, checked: Boolean(_ctx.value) }]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitUpdate && _ctx.emitUpdate(...args)), ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (Boolean(_ctx.value))
        ? (_openBlock(), _createElementBlock("i", _hoisted_2))
        : _createCommentVNode("", true),
      (Boolean(_ctx.value))
        ? (_openBlock(), _createElementBlock("i", _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    (Boolean(_ctx.label))
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true)
  ], 2))
}